import React, { Component } from "react";
import SideBar from "../common/sideBar";
import UserProfile from "../common/userProfile";
import ScrollTop from "../common/scrollTop";
import HelmetComponent from "../common/helmetComponent";
import { connect } from "react-redux";
import PatientGrid from "./patientGrid";
import Pagination from "../common/Pagination";
import Search from "./search";
import {
  getProduct,
  loadAllPatient,
  deletedPatient,
  updatePatient,
} from "../../store/patient";
import { deleted, activated, deactivated, failed } from "../common/misc";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import SortingIcon from "../common/sortingIcon";
import SortingIconUp from "../common/sortingIconUp";
import AlertSuccess from "../common/alertSuccess";
import PatientEmpty from "./patientEmpty";

class PatientTable extends Component {
  state = {
    userShow: false,
    modal: false,
    editModal: false,
    active: false,
    id: "",
    patient_id: "",
    status: "",
    msg: "",
    isShow: false,
    data: "",
    totalRecords: "",
    totalPages: "",
    pageLimit: "",
    currentPage: "",
    delete_id: "",
    asside: false,
    asside2: false,
    sort_by: "created_on",
    sort: "desc",
    asside3: false,
    first_name: "",
    mobile: "",
    email: "",
  };
  onSearch = (e) => {
    e.preventDefault();
    if (this.state.first_name) {
      this.props.loadAllPatient({
        first_name: this.state.first_name,
        page: this.state.currentPage,
      });
    } else if (this.state.mobile) {
      this.props.loadAllPatient({
        mobile: this.state.mobile,
        page: this.state.currentPage,
      });
    } else if (this.state.email) {
      this.props.loadAllPatient({
        email: this.state.email,
        page: this.state.currentPage,
      });
    }
  };
  reset = () => {
    this.props.loadAllPatient({ page: this.props.currentPage });
    this.setState({ first_name: "", email: "", mobile: "" });
  };
  toggleAsside = () => {
    this.setState({
      asside2: false,
      asside3: false,
      asside: !this.state.asside,
    });
  };
  toggleAsside2 = () => {
    this.setState({
      asside: false,
      asside3: false,
      asside2: !this.state.asside2,
    });
  };
  toggleAsside3 = () => {
    this.setState({
      asside2: false,
      asside3: !this.state.asside3,
      asside: false,
    });
  };
  toggleShowUser = () => {
    this.setState({
      userShow: !this.state.userShow,
    });
  };
  toggle = (id) => {
    this.setState({
      modal: !this.state.modal,
      delete_id: id,
    });
  };
  toggleAcitve = (id, status, msg) => {
    this.setState({
      active: !this.state.active,
      patient_id: id,
      status: status,
      msg: msg,
    });
  };
  toggleEditUser = (data, id) => {
    this.setState({
      isShow: !this.state.isShow,
      data: data,
      id: id,
    });
  };

  sortByName = () => {
    if (this.state.sort === "desc")
      this.setState({
        sort_by: "first_name",
        sort: "asc",
      });
    else {
      this.setState({
        sort_by: "first_name",
        sort: "desc",
      });
    }
  };
  sortByEmail = () => {
    if (this.state.sort === "desc")
      this.setState({
        sort_by: "email",
        sort: "asc",
      });
    else {
      this.setState({
        sort_by: "email",
        sort: "desc",
      });
    }
  };

  sortByDOB = () => {
    if (this.state.sort === "desc")
      this.setState({
        sort_by: "date_of_birth",
        sort: "asc",
      });
    else {
      this.setState({
        sort_by: "date_of_birth",
        sort: "desc",
      });
    }
  };
  sortBystatus = () => {
    if (this.state.sort === "desc")
      this.setState({
        sort_by: "status",
        sort: "asc",
      });
    else {
      this.setState({
        sort_by: "status",
        sort: "desc",
      });
    }
  };
  sortByCreated = () => {
    if (this.state.sort === "desc")
      this.setState({
        sort_by: "created_on",
        sort: "asc",
      });
    else {
      this.setState({
        sort_by: "created_on",
        sort: "desc",
      });
    }
  };
  deletedPatient = (id) => {
    this.props.deletedPatient(id, this.callback);
  };
  callback = (res) => {
    if (res && res.status === 200) {
      this.props.loadAllPatient({ page: this.state.currentPage });
      this.setState({
        modal: !this.state.modal,
      });
      toast(<AlertSuccess message={deleted} />);
    } else {
      toast(<AlertError message={failed} />);
    }
  };
  UpdatePatient = (id) => {
    const formData = {
      is_active: this.state.status,
    };
    this.props.updatePatient(id, formData, this.callbackActive);
  };
  callbackActive = (res) => {
    if (res && res.status === 200) {
      this.props.loadAllPatient({ page: this.state.currentPage });
      this.setState({
        active: !this.state.active,
      });
      if (this.state.status === true) {
        toast(<AlertSuccess message={activated} />);
      } else {
        toast(<AlertSuccess message={deactivated} />);
      }
    } else {
      toast(<AlertError message={failed} />);
    }
  };

  componentDidMount = () => {
    if (this.state.currentPage) {
      this.props.loadAllPatient({
        page: this.state.currentPage,
        sort_by: this.state.sort_by,
        sort: this.state.sort,
      });
    }
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.sort_by != prevState.sort_by ||
      this.state.sort != prevState.sort
    ) {
      this.props.loadAllPatient({
        page: this.state.currentPage,
        sort_by: this.state.sort_by,
        sort: this.state.sort,
      });
    }
  };

  onChangePage = (data) => {
    this.setState({
      pageLimit: data.pageLimit,
      totalPages: data.totalPages,
      currentPage: data.page,
    });
    if (data.page != this.state.currentPage && this.state.first_name) {
      this.props.loadAllPatient({
        page: data.page,
        first_name: this.state.first_name,
      });
    } else if (data.page != this.state.currentPage && this.state.email) {
      this.props.loadAllPatient({ page: data.page, email: this.state.email });
    } else if (data.page != this.state.currentPage && this.state.mobile) {
      this.props.loadAllPatient({ page: data.page, mobile: this.state.mobile });
    } else if (data.page != this.state.currentPage) {
      this.props.loadAllPatient({
        page: data.page,
        sort_by: this.state.sort_by,
        sort: this.state.sort,
      });
    }
  };
  changeFirstname = (firstname) => {
    this.setState({ first_name: firstname });
  };
  changeEmail = (email) => {
    this.setState({ email: email });
  };
  changeMobile = (mobile) => {
    this.setState({ mobile: mobile });
  };
  render() {
    const { patient, loading } = this.props.patient;
    const { record_per_page, total_page, current_page, filtered_record } =
      this.props.pagination;
    return (
      <div
        className={
          this.state.asside === true ||
          this.state.asside2 === true ||
          this.state.asside3 === true
            ? "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled"
            : "header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled aside-minimize"
        }
      >
        <div className="d-flex flex-column flex-root">
          <HelmetComponent title="Patients Management" />
          <div className="d-flex flex-row flex-column-fluid page">
            <SideBar
              toggleAsside={this.toggleAsside}
              toggleAsside3={this.toggleAsside3}
              userShow={this.state.userShow}
              toggleShowUser={this.toggleShowUser}
              asside={this.state.asside}
              asside3={this.state.asside3}
              asside2={this.state.asside2}
              toggleAsside2={this.toggleAsside2}
            />
            <div
              className="d-flex flex-column flex-row-fluid wrapper"
              id="kt_wrapper"
            >
              <div className="content d-flex flex-column flex-column-fluid">
                <div className="subheader py-2 py-lg-4 subheader-transparent">
                  <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div className="d-flex align-items-center flex-wrap mr-2 ">
                      <h5 className="text-dark font-weight-bold mt-2 mb-2 mr-5">
                        Patients
                      </h5>
                      <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                      <div className="d-flex align-items-center">
                        <span className="text-dark-50 font-weight-bold">
                          {filtered_record > 0
                            ? "Total :" +
                              " " +
                              filtered_record +
                              " " +
                              "records"
                            : "Total : 0 record"}
                        </span>
                        <Search
                          reset={this.reset}
                          mobile={this.state.mobile}
                          email={this.state.email}
                          changeMobile={this.changeMobile}
                          changeEmail={this.changeEmail}
                          changeFirstname={this.changeFirstname}
                          currentPage={current_page}
                          first_name={this.state.first_name}
                          onSearch={this.onSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column-fluid">
                  <div className="container-fluid">
                    <div className="card card-custom">
                      <div className="card-header flex-wrap border-0 pt-6 pb-0">
                        <div className="card-title">
                          <h3 className="card-label">
                            Patients Management
                            <span className="d-block text-muted pt-2 font-size-sm">
                              You can view/delete/activate/deactivate patients.
                            </span>
                          </h3>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded">
                          <table
                            className="datatable-table"
                            style={{ display: "block" }}
                          >
                            <thead className="datatable-head">
                              <tr
                                className="datatable-row"
                                style={{ left: "0px" }}
                              >
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "150px" }}>
                                    Name
                                    {this.state.sort_by === "first_name" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon sorting={this.sortByName} />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByName}
                                      />
                                    )}
                                  </span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "250px" }}>
                                    Email
                                    {this.state.sort_by === "email" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon sorting={this.sortByEmail} />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByEmail}
                                      />
                                    )}{" "}
                                  </span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "100px" }}>
                                    {" "}
                                    DOB
                                    {this.state.sort_by === "date_of_birth" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon sorting={this.sortByDOB} />
                                    ) : (
                                      <SortingIconUp sorting={this.sortByDOB} />
                                    )}{" "}
                                  </span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "125px" }}>Type</span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "80px" }}>
                                    Status
                                    {this.state.sort_by === "status" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon
                                        sorting={this.sortBystatus}
                                      />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortBystatus}
                                      />
                                    )}
                                  </span>
                                </th>
                                <th className="datatable-cell datatable-cell-sort">
                                  <span style={{ width: "140px" }}>
                                    Created On
                                    {this.state.sort_by === "created_on" &&
                                    this.state.sort === "asc" ? (
                                      <SortingIcon
                                        sorting={this.sortByCreated}
                                      />
                                    ) : (
                                      <SortingIconUp
                                        sorting={this.sortByCreated}
                                      />
                                    )}{" "}
                                  </span>
                                </th>
                                <th
                                  data-field="Status"
                                  className="datatable-cell datatable-cell-sort"
                                >
                                  <span style={{ width: "145px" }}>Action</span>
                                </th>
                              </tr>
                            </thead>
                            {loading === false && patient.length === 0 ? (
                              <PatientEmpty />
                            ) : (
                              <PatientGrid
                                initialPage={this.state.current_page}
                                delete_id={this.state.delete_id}
                                isShow={this.state.isShow}
                                toggleEditUser={this.toggleEditUser}
                                data={this.state.data}
                                msg={this.state.msg}
                                status_id={this.state.patient_id}
                                modalActive={this.state.active}
                                toggleAcitve={this.toggleAcitve}
                                Update={this.UpdatePatient}
                                modal={this.state.modal}
                                toggle={this.toggle}
                                id={this.state.id}
                                patient={patient}
                                deleted={this.deletedPatient}
                              />
                            )}
                          </table>
                          <Pagination
                            totalRecords={filtered_record}
                            total_page={total_page}
                            pageLimit={record_per_page}
                            initialPage={current_page}
                            pagesToShow={5}
                            onChangePage={this.onChangePage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <UserProfile
            userShow={this.state.userShow}
            toggleShowUser={this.toggleShowUser}
          />
          <ScrollTop />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  patient: getProduct(state),
  pagination: getProduct(state).pagination,
});
const mapDispatchToProps = (dispatch) => ({
  loadAllPatient: (params) => dispatch(loadAllPatient(params)),
  deletedPatient: (id, callback) => dispatch(deletedPatient(id, callback)),
  updatePatient: (id, data, callbackActive) =>
    dispatch(updatePatient(id, data, callbackActive)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientTable);
